import { Modal } from 'flowbite-react';
import React from 'react';
import TakeProfilePhoto from 'src/pages/TakeProfilePhoto';

const TakePhotoModal = ({
	openModal,
	setOpenModal,
	userId,
	onFinish,
}: {
	openModal: boolean;
	setOpenModal: (e: boolean) => void;
	userId?: string;
	onFinish?: () => void;
}) => {
	return (
		<Modal show={openModal} onClose={() => setOpenModal(false)}>
			<Modal.Header>Please take a photo</Modal.Header>
			<Modal.Body className="h-fit">
				<TakeProfilePhoto isModal userId={userId} onFinish={onFinish} />
			</Modal.Body>
		</Modal>
	);
};

export default TakePhotoModal;
